export default "__VITE_ASSET__yZ_9obyi__"